export default class VendorGuard {
    static middleware({store, to}) {
        try {
            store.dispatch('updateIntercomUser');

            if (store.getters['user/isTrackable']) {
                const {fullPath} = to;
                // if the path isn't excluded then send GTM the pageview event
                if (!['remote-login'].some(slug => fullPath.includes(slug))) {
                    store.dispatch('triggerGTMEvent', {
                        event: 'pageview',
                        page: fullPath,
                    });
                }
            }
        } catch (error) {
            // TODO handle unexpected errors
        }
    }
}
